export const workOfferInfoFrag = `
    offers {
        offerId
        applications
        operations
        procedures
    }
`;
